<div class="modal-overlay">
  <div class="card mx-auto border-0">
    <div class="card-header bergh-bg-primary text-white h5">
      Verplaats brandpartities
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          @if (!isBulkMove) {
          <span class="size"
            >Een of meer brandpartities buiten de zone. Probeer deze binnen de
            zone te verplaatsen a.u.b. zone<br />
            probeer te bewegen binnen de zone
          </span>
          } @if (commonFpList.length !== 0) {
          <span class="size"
            >Wilt u de brandpartitie verplaatsen van overlappende zone naar
            geselecteerde zone?</span
          >
          }
        </div>
        @if (commonFpList.length !== 0) {
        <div class="row pl-4 pr-4">
          <div class="w-100">
            Totaal aantal brandscheiding(en) om te verplaatsen:
            {{ commonFpList.length }}
          </div>
          <table class="table table-striped w-100 mt-3">
            <tbody>
              @for (fp of commonFpList; track fp; let i = $index) {
              <tr>
                <td>
                  {{ fp.fp.code }}
                </td>
                <td>
                  <select
                    #val
                    class="custom-select custom-select"
                    id="ddwn-map"
                    (change)="getSelectedZone(val.value, i, fp)"
                  >
                    @for (data of fp.zone; track data; let j = $index) {
                    <option [value]="data.zone_id" id="option_{j}">
                      {{ data.name }}
                    </option>
                    }
                  </select>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        }
      </div>
    </div>
    <div class="card-footer bg-white d-flex justify-content-end">
      @if (commonFpList.length !== 0 && !isEdit) {
      <button
        class="btn btn-success mr-2 col-4"
        (click)="getAllSelectedData(true)"
        id="btn_move"
      >
        Verplaatsen
      </button>
      } @if (commonFpList.length !== 0 && !isEdit) {
      <button
        class="btn btn-danger mr-2"
        (click)="getAllSelectedData(false)"
        id="btn_move"
      >
        Niet verplaatsen
      </button>
      } @if (commonFpList.length !== 0 && isEdit) {
      <button
        class="btn btn-success mr-2"
        (click)="getDataIfNoSelected(true)"
        id="btn-cancel"
      >
        Verplaatsen
      </button>
      } @if (commonFpList.length !== 0) {
      <button
        class="btn btn-secondary mr-2"
        (click)="cancel.emit(false)"
        id="btn-cancel"
      >
        Dichtbij
      </button>
      } @if (commonFpList.length === 0) {
      <button
        class="btn btn-secondary mr-2"
        (click)="cancel.emit(false)"
        id="btn-cancel"
      >
        Ok
      </button>
      }
    </div>
  </div>
</div>
